import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { SUPPORTED_LANGUAGES, setLanguage, type Language } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** ชื่อภาษาเขียนด้วยภาษานั้นเองเสมอ ไม่ต้องแปล (ผู้ใช้ต้องอ่านออกแม้ยังไม่ได้สลับภาษา) */
const LABELS: Record<Language, string> = { th: 'ไทย', en: 'English' };

/** สลับภาษาได้จากหน้าแรก — มีผู้เข้าอบรมต่างชาติ */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = i18n.language.startsWith('th') ? 'th' : 'en';

  return (
    <div className="flex items-center gap-1" role="group" aria-label={t('common.language')}>
      <Languages aria-hidden className="mr-1 h-4 w-4 text-slate-500" />
      {SUPPORTED_LANGUAGES.map((language) => (
        <button
          key={language}
          type="button"
          onClick={() => setLanguage(language)}
          aria-pressed={current === language}
          className={cn(
            'rounded-md px-2.5 py-1 text-sm transition-colors',
            current === language
              ? 'bg-slate-900 text-white'
              : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
          )}
        >
          {LABELS[language]}
        </button>
      ))}
    </div>
  );
}
